export const splashScreenDomId = 'splash-screen';
export const portalDomId = 'portal';
export const yaMapDomId = 'id-container-ya-map';
